import React, { forwardRef } from 'react';

import { Box, Checkbox, FormGroup, Stack, styled } from '@mui/material';

import Check from 'images/components/check.svg';
import CheckboxIcon from 'images/components/checkbox.svg';

const StyledCheckbox = styled(Checkbox)(({ theme, disabled }) => ({
  padding          : '0 0 0 0',
  '& .StyledLabel' : {
    padding   : '15px 15px 15px 50px',
    minHeight : '50px',
    width     : '100%',

    background : disabled
      ? theme.palette.primary.gray4
      : theme.palette.primary.white,
    backgroundImage    : `url(${CheckboxIcon})`,
    backgroundRepeat   : 'no-repeat',
    backgroundPosition : '18px 50%',

    color         : theme.palette.primary.gray100,
    fontFamily    : 'Montserrat',
    fontWeight    : 400,
    fontSize      : '14px',
    fontStyle     : 'normal',
    lineHeight    : '17px',
    textTransform : 'none',
    textAlign     : 'left',
    wordWrap      : 'normal',
    opacity       : 0.8,

    borderWidth  : '1px',
    borderStyle  : 'solid',
    borderColor  : theme.palette.primary.gray15,
    borderRadius : '6px',
    position     : 'relative',

    boxSizing : 'border-box',
    resize    : 'none',
  },
  '&:hover' : {
    '& .StyledLabel:not(.StyledLabel-checked)' : {
      borderColor : theme.palette.primary.blue1,
      borderWidth : '2px',
      color       : theme.palette.primary.blue1,
      fonntWeight : 700,
    },
  },
  '& .StyledLabel-checked' : {
    backgroundImage : `url(${Check})`,
    fontWeight      : 600,
    color           : theme.palette.primary.blue1,
    boxShadow       : `0 0 0 2px ${theme.palette.primary.blue1}`,
    borderColor     : 'rgba(0, 0, 0, 0)',
  },
}));

export const CheckboxInput = (props) => {
  const { label, ...rest } = props;
  return (
    <StyledCheckbox
      data-testid='checkbox-input'
      disableRipple
      color='default'
      checkedIcon={
        <Box
          className='StyledLabel StyledLabel-checked'>{label}</Box>
      }
      icon={<Box
        className='StyledLabel'>{label}</Box>}
      {...rest}
    />
  );
};

export const CheckboxGroupInput = forwardRef(
  ({ children, direction = 'column', optionsStyles, ...rest }, ref) => (
    <FormGroup
      {...rest} ref={ref}>
      <Stack
        spacing='15px' direction={direction} sx={optionsStyles}>
        {children}
      </Stack>
    </FormGroup>
  )
);
